/** Hide company when blank or the same as the person's name (avoids "Peter Peter"). */
export function companyNameUnlessSameAsPerson(
  companyName: string | undefined | null,
  personName: string | undefined | null
): string {
  const company = String(companyName || '').trim();
  if (!company) return '';
  const person = String(personName || '').trim();
  if (person && company.toLowerCase() === person.toLowerCase()) return '';
  return company;
}
